import { render, staticRenderFns } from "./AddStatus.vue?vue&type=template&id=fe975ab6"
import script from "./AddStatus.vue?vue&type=script&lang=js"
export * from "./AddStatus.vue?vue&type=script&lang=js"
import style0 from "./AddStatus.vue?vue&type=style&index=0&id=fe975ab6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports